import { apiClient } from "api";
import { Dayjs } from "dayjs";
import { TJobSummary } from "./models/types";

export const getJobSummary = async (
  accountId: string,
  summaryDate: Dayjs
): Promise<TJobSummary[]> => {
  const response = await apiClient.get(`jobSummary/${accountId}`, {
    params: { summaryDate: summaryDate.format("YYYY-MM-DD") }
  });
  return response.data;
};
